import { Col, Row, Card } from 'react-bootstrap';
import estrellaIcon from 'assets/img/landing/tarjetas/estrella.svg';
import coheteIcon from 'assets/img/landing/tarjetas/cohete.svg';
import maletinIcon from 'assets/img/landing/tarjetas/maletin.svg';

const PorQueNosotros = () => {
  return (
    <section className="py-10 bg-body">
      <div className="container-small px-lg-7 px-xxl-3 text-center">
        <h2 className="mb-6 fw-bold">¿Por qué nosotros?</h2>
        
        <Row className="g-4 text-start">
          <Col xs={12} md={4}>
            <Card className="h-100 border-0 shadow-sm bg-body-tertiary">
              <Card.Body className="p-4 text-center">
                <img src={estrellaIcon} alt="Estrella" className="mb-3" width="40" />
                <h4 className="fw-bold mb-2">Valoración</h4>
                <p className="text-muted fs-9 mb-0">Somos un estudio jurídico con una sólida trayectoria, reconocido por la calidad de nuestros servicios. Contamos con numerosas valoraciones positivas que avalan nuestra dedicación y compromiso en cada caso. Tu confianza es nuestra prioridad.</p>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card className="h-100 border-0 shadow-sm bg-body-tertiary">
              <Card.Body className="p-4 text-center">
                <img src={coheteIcon} alt="Cohete" className="mb-3" width="40" />
                <h4 className="fw-bold mb-2">Rapidez</h4>
                <p className="text-muted fs-9 mb-0">Ofrecemos agilidad y eficiencia en cada etapa del proceso, brindando acompañamiento constante y priorizando una solución rápida y efectiva para tu reclamo, con el máximo cuidado y profesionalismo.</p>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card className="h-100 border-0 shadow-sm bg-body-tertiary">
              <Card.Body className="p-4 text-center">
                <img src={maletinIcon} alt="Maletín" className="mb-3" width="40" />
                <h4 className="fw-bold mb-2">Experiencia</h4>
                <p className="text-muted fs-9 mb-0">Nuestro estudio jurídico abrió sus puertas en el año 1973. Nos especializamos en derecho laboral hace mas de 52 años y hemos ayudado a miles de trabajadores a defender sus derechos.</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default PorQueNosotros;